export const RETAILOR_JS_TEMPLATE = `/* START RETAILORMEDIA JS TRACKING - {{PROVIDER_NAME}} - ProviderID: {{PROVIDER_ID}} */
(function(m,e,d,i,a){m[d]=m[d]||{};m[d].providerId=i;m[d].options=m[d].options||a;
var f='ready';m[d][f]=m[d][f]||function(z){m[d][f].q=m[d][f].q||[];if(typeof z=='function')
{m[d][f].q.push(z);return m[d];}return new Promise(function(r){m[d][f].q.push(r)});};
var s=e.createElement('script');s.setAttribute('global',d);s.async=!0;
s.src='https://js.retailor.media/route.js';e.querySelector('head,body').appendChild(s);})
(window,document,'__retailor','{{PROVIDER_ID}}',{autostart:{{AUTOSTART}}});
/* END RETAILOR MEDIA JS TRACKING */`;
